import { Box, Text } from '@chakra-ui/react'

type EnvsWithFlags = 'hml' | 'dev'

interface Flags {
    color: string
    label: string
}

export const EnvironmentFlag: React.FC = () => {
    const flagsByEnvironments = (): Flags | undefined => {
        const environment = process.env.REACT_APP_ENV

        if (environment === 'prd' || !environment) return

        const environments: Record<EnvsWithFlags, Flags> = {
            hml: {
                color: '#18315a',
                label: 'Homologação'
            },
            dev: {
                color: '#FF9800',
                label: 'Desenvolvimento'
            }
        }

        return environments[environment as EnvsWithFlags]
    }

    const flags = flagsByEnvironments()

    return (
        <>
            {flags && (
                <Box
                    marginY="8px"
                    flex={'center'}
                    justifyContent={'center'}
                    textAlign={'center'}
                    borderRadius={'4px'}
                >
                    <Text
                        fontWeight={600}
                        fontSize="16px"
                        color={flags.color}
                        textDecoration={'underline'}
                    >
                        {flags.label}
                    </Text>
                </Box>
            )}
        </>
    )
}
